import { render } from "./healthReportForm.vue?vue&type=template&id=97d751f6&scoped=true"
import script from "./healthReportForm.vue?vue&type=script&lang=js"
export * from "./healthReportForm.vue?vue&type=script&lang=js"

import "./healthReportForm.vue?vue&type=style&index=0&id=97d751f6&lang=css"
import "./healthReportForm.vue?vue&type=style&index=1&id=97d751f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d751f6"]])

export default __exports__